<template>
    <div class="modal modal--rebrand over-all" id="modalNotLoggedIn" tabindex="-1" role="dialog"
         aria-labelledby="modalNotLoggedInTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body text-center d-flex flex-column justify-content-center">
                    <p class="m-0">{{ translate.home.needToLogin }}</p>
                </div>

                <div class="modal-footer d-flex flex-column justify-content-center">
                    <a :href="regionRelativeUrl('/users/login/')" class="btn btn-rebrand-primary btn-rebrand-sm">{{ translate.login.login }}</a>
                    <a :href="regionRelativeUrl('/users/registration/')" class="btn btn-rebrand-grey-outline btn-rebrand-sm mt-3">{{ translate.home.registerNow }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";

export default {
    beforeDestroy() {
        window.clearModalFade();
    },
    computed: {
        ...mapState(['translate']),
    },
    mixins: [
        regionsUrlMixin,
    ],
};
</script>
